// SHADOW MARKET™ — 5 Kids animated characters (Satoshi, Hodl, Miner, Oracle, Bear).
import React from "react";

const COLORS = {
  satoshi: { cabeza: "#f5a623", cuerpo: "#1a3a6a", acento: "#f5a623" },
  hodl:    { cabeza: "#00c864", cuerpo: "#0a3a1a", acento: "#00c864" },
  miner:   { cabeza: "#00d4ff", cuerpo: "#0a2030", acento: "#00d4ff" },
  oracle:  { cabeza: "#9b59ff", cuerpo: "#1a0a30", acento: "#9b59ff" },
  bear:    { cabeza: "#ff3355", cuerpo: "#2a0a14", acento: "#ff3355" },
};
const SYMBOLS = { satoshi: "₿", hodl: "💰", miner: "⛏", oracle: "🔮", bear: "📉" };
const NAMES = {
  satoshi: "Satoshi",
  hodl: "Hodl Hero",
  miner: "Miner Mike",
  oracle: "Oracle",
  bear: "Bear Barry",
};

export const Personaje = ({ id = "satoshi", estado = "idle", size = 110, label = false }) => {
  const c = COLORS[id] || COLORS.satoshi;
  const sym = SYMBOLS[id] || "★";
  const anim =
    estado === "feliz"
      ? "kidsBounce 0.5s ease infinite alternate"
      : estado === "triste"
      ? "kidsShake 0.3s ease infinite"
      : estado === "hablar"
      ? "kidsTalk 0.18s ease infinite alternate"
      : "kidsFloat 3s ease-in-out infinite";
  const bocaAbierta = estado === "hablar";

  return (
    <div className="inline-flex flex-col items-center" data-testid={`kids-personaje-${id}`}>
      <style>{`
        @keyframes kidsBounce { from{transform:translateY(0)} to{transform:translateY(-14px)} }
        @keyframes kidsShake  { 0%{transform:rotate(-3deg)} 100%{transform:rotate(3deg)} }
        @keyframes kidsTalk   { from{transform:scaleY(1)} to{transform:scaleY(1.05)} }
        @keyframes kidsFloat  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
      `}</style>
      <div style={{ width: size, height: size * 1.35, animation: anim, transformOrigin: "center bottom" }}>
        <svg viewBox="0 0 60 80" width={size} height={size * 1.35} xmlns="http://www.w3.org/2000/svg">
          {/* shadow */}
          <ellipse cx="30" cy="78" rx="18" ry="2" fill="rgba(0,0,0,0.35)" />
          {/* arms */}
          <rect x="0"  y="36" width="10" height="18" rx="3" fill={c.cabeza} stroke={c.acento} strokeWidth="1.5"/>
          <rect x="50" y="36" width="10" height="18" rx="3" fill={c.cabeza} stroke={c.acento} strokeWidth="1.5"/>
          {/* body */}
          <rect x="12" y="34" width="36" height="26" rx="6" fill={c.cuerpo} stroke={c.acento} strokeWidth="1.5"/>
          <text x="30" y="51" textAnchor="middle" fontSize="16" fill={c.acento}>{sym}</text>
          {/* legs */}
          <rect x="15" y="60" width="11" height="14" rx="3" fill={c.cuerpo} stroke={c.acento} strokeWidth="1.5"/>
          <rect x="34" y="60" width="11" height="14" rx="3" fill={c.cuerpo} stroke={c.acento} strokeWidth="1.5"/>
          {/* head */}
          <rect x="14" y="4" width="32" height="28" rx="6" fill={c.cabeza} stroke={c.acento} strokeWidth="1.5"/>
          {/* eyes */}
          <rect x="19" y="13" width="7" height="6" rx="2" fill="#0a0b16"/>
          <rect x="34" y="13" width="7" height="6" rx="2" fill="#0a0b16"/>
          <circle cx="21" cy="14.5" r="1.4" fill="rgba(255,255,255,.7)"/>
          <circle cx="36" cy="14.5" r="1.4" fill="rgba(255,255,255,.7)"/>
          {/* mouth */}
          {bocaAbierta ? (
            <ellipse cx="30" cy="26" rx="6" ry="4" fill="#0a0b16"/>
          ) : (
            <rect x="23" y="24" width="14" height="3" rx="1.5" fill="#0a0b16" opacity="0.8"/>
          )}
        </svg>
      </div>
      {label && (
        <div
          className="mt-1 rounded-full border px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-[0.18em]"
          style={{ borderColor: `${c.acento}55`, color: c.acento, background: `${c.acento}14` }}
        >
          {NAMES[id]}
        </div>
      )}
    </div>
  );
};

export const PERSONAJE_COLORS = COLORS;
export const PERSONAJE_NAMES = NAMES;
